<script setup>
import { ref, onMounted } from "vue";

const props = defineProps({
    filterId: { type: String, required: true },
    label:    { type: String, required: true },
});

const model = defineModel();

const localValue = ref(false);

onMounted(() => {
    const params = new URLSearchParams(window.location.search);
    const urlValue = params.get(props.filterId);
    if (urlValue === '1' || urlValue === 'true') {
        setTimeout(() => {
            localValue.value = true;
            model.value = 1;
        });
    }
});

const onChange = (val) => {
    localValue.value = val;
    model.value = val ? 1 : null;
};

const clear = () => {
    localValue.value = false;
    model.value = null;
};

defineExpose({ clear });
</script>

<template>
    <b-field :label="label" custom-class="mb-3">
        <b-checkbox :id="filterId" :model-value="localValue" @update:modelValue="onChange"/>
    </b-field>
</template>
